// import { calcShortcutInterval } from '@utils';
import moment from 'moment';
import { DATE_SHORTCUTS } from '@utils/constants';

export const getDateShortcutsWithInterval = (SHORTCUTS) => {
  return Object.keys(SHORTCUTS).map(key => {
    return [SHORTCUTS[key], calcShortcutInterval(DATE_SHORTCUTS[key])]
  });
}

function calcShortcutInterval(shortcut) {
  switch (shortcut) {
  case DATE_SHORTCUTS.today: return [moment().startOf('day'), moment()];
  case DATE_SHORTCUTS.past7Days: return [moment().subtract(6, 'days'), moment()];
  case DATE_SHORTCUTS.past15Days: return [moment().subtract(14, 'days'), moment()];
  case DATE_SHORTCUTS.past30Days: return [moment().subtract(29, 'days'), moment()];
  default: return [];
  }
}

export const getLocalTime = (cutoffDate, tzOffset) => {
  return moment.utc(cutoffDate).utcOffset(tzOffset).format();
}

// cutoffDate - date from which the data for the dashboard is available
export const shouldHide = (from , cutoffDate, tzOffset, shortcut) => {
  if (!cutoffDate) {
    return false;
  }

  const fromDate = moment(from).format();
  const allowedLocalTime = getLocalTime(cutoffDate, tzOffset);

  // fromDate < allowedLocalTime
  // checks if the shortcut's from date is before the allowed time
  if (moment(fromDate).isBefore(moment(allowedLocalTime).startOf('day'))) {
    return true;
  }

  return false;
}
